import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./Styles.css"; // CSS específico para o botão

export default function ButtonWhatsapp() {
  return (
    <a
      href="https://wa.me/5515996879862?text=Olá!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20serviço%20de%20manutenção."
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-floating"
    >
      <FaWhatsapp />
    </a>
  );
}
